export const LANDING_NAME_ROUTER = 'Landing';
export const CHUSPIC_LAYOUT_WEB = 'ChuspicLayoutWeb';

export const LandingRouter = [
    {
        path: '/landing',
        name: 'Landing',
        component: () => import('@/views/Landing/Index.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/contact',
        name: 'ContactLanding',
        component: () => import('@/views/Landing/Contact.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/terms-conditions',
        name: 'TermsConditionsChuspic',
        component: () => import('@/views/Landing/TermConditionsChuspic.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/privacy-policies',
        name: 'PrivacyPoliciesChuspic',
        component: () => import('@/views/Landing/PrivacyPoliciesChuspic.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/register',
        name: 'Register',
        component: () => import('@/views/Landing/Register.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/plans',
        name: 'Plans',
        component: () => import('@/views/Landing/Plans.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/profile',
        name: 'LandingProfile',
        component: () => import('@/views/user/Profile.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
    {
        path: '/landing/thank-you',
        name: 'LandingThankYou',
        component: () => import('@/views/Landing/ThankYou.vue'),
        meta: {layout: CHUSPIC_LAYOUT_WEB}
    },
];